/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_Outcome_HitInputs */

const cs_lustrace_outcome_hit = /** @type {(inputs: Lustrace_Outcome_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nález`)
};

const en_lustrace_outcome_hit = /** @type {(inputs: Lustrace_Outcome_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit`)
};

/**
* | output |
* | --- |
* | "Hit" |
*
* @param {Lustrace_Outcome_HitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_outcome_hit = /** @type {((inputs?: Lustrace_Outcome_HitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_Outcome_HitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_outcome_hit(inputs)
	return cs_lustrace_outcome_hit(inputs)
});